import { DashboardProfile, Payment, Subscription } from 'types/user';

const ACCESS_STATUSES = new Set(['active', 'completed', 'paid', 'succeeded']);

const normalizeStatus = (status: string) => status.trim().toLowerCase();

export const hasActiveSubscription = (subscriptions: Subscription[]) =>
  subscriptions.some((subscription) => ACCESS_STATUSES.has(normalizeStatus(subscription.status)));

export const hasActivePayment = (payments: Payment[]) =>
  payments.some((payment) => ACCESS_STATUSES.has(normalizeStatus(payment.status)));

export const hasDashboardAccess = (dashboard: DashboardProfile) =>
  hasActiveSubscription(dashboard.subscriptions) || hasActivePayment(dashboard.payments);
